import { useTranslation } from 'libs/i18n';

import {
  OnboardingAccountsInOrganizationsFormType,
  FormErrors,
  getSchema,
} from '../../forms/onboardingAccountsInOrganizationsForm';
import { ClientType, FormBodyWrapper } from '../FormBodyWrapper';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: OnboardingAccountsInOrganizationsFormType;
  onSubmit: (values: OnboardingAccountsInOrganizationsFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
}

export const OnboardingAccountsInOrganizations = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  clientType,
  ...formProps
}: Props) => {
  const schema = getSchema();
  const { t } = useTranslation();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={t('onboarding.accountsInOrganizations.subtitle')}
      title={t('onboarding.accountsInOrganizations.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
